<template>
  <BoardView :title="laptop.name">
    <a
      slot="button"
      class="Btn"
      :href="laptop.link"
      target="_blank">
      {{ $t('linkToAmazon') }}
    </a>
    <FormValidation @submit="save">
      <FormLaptop
        :laptop.sync="laptop" />
      <Btn
        v-if="hasRole('>=MODERATOR')"
        class="info"
        :isLoading="isSaving"
        type="submit">
        {{ $t('submit') }}
      </Btn>
    </FormValidation>
  </BoardView>
</template>

<script>
import BoardSingle from '@mixins/BoardSingle'
import FormLaptop from '@forms/FormLaptop'

export default {
  mixins: [BoardSingle('laptop')],
  components: { FormLaptop },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "submit": "Update",
    "linkToAmazon": "Link to Amazon"
  }
}
</i18n>
